import React from 'react';
import { useLocation } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from '@mui/material';
import { SidebarWidth } from 'theme/variables';
import { useAppContext } from 'context/AppContextProvider';

import BegigLogo from '../Logo/BegigLogo';
import Menuitems from './data';

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: SidebarWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: SidebarWidth,
    boxSizing: 'border-box',
    borderRight: `1px solid ${theme.palette.grey[200]}`,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SidebarContent = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3, 1),
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(4),
}));

const StyledList = styled(List)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: 0,
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.common.white,
    },
  },
}));

const isItemActive = ({ pathname, href }) => {
  let pathChunk = pathname.split('/').slice(0, 2).join('/');
  return href.includes(pathChunk) || pathChunk.includes(href);
};

const Sidebar = ({ isDesktop }) => {
  const { pathname } = useLocation();
  const { isSidebarOpen, isMobileSidebarOpen, setMobileSidebarOpen } =
    useAppContext();

  const handleClick = () => {
    if (!isDesktop) {
      setMobileSidebarOpen(false);
    }
  };

  const sidebarContent = (
    <SidebarContent>
      <Link to="/">
        <LogoContainer>
          <BegigLogo width="80" />
        </LogoContainer>
      </Link>
      <StyledList>
        {Menuitems.map((item) => {
          const isActive = isItemActive({ pathname, href: item.href });

          return (
            <StyledListItemButton
              key={item.title}
              component={NavLink}
              to={item.href}
              onClick={handleClick}
              selected={isActive}
            >
              <ListItemIcon>
                <item.icon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{ fontSize: '14px' }}
              />
            </StyledListItemButton>
          );
        })}
      </StyledList>
    </SidebarContent>
  );

  if (isDesktop) {
    return (
      <StyledDrawer
        variant="persistent"
        anchor="left"
        open={isSidebarOpen}
      >
        {sidebarContent}
      </StyledDrawer>
    );
  }

  return (
    <StyledDrawer
      variant="temporary"
      anchor="left"
      open={isMobileSidebarOpen}
      onClose={() => setMobileSidebarOpen(false)}
    >
      {sidebarContent}
    </StyledDrawer>
  );
};

export default Sidebar;
